module.exports = __webpack_public_path__ + "static/spindal.929fadf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/clients/images/spindal.png
// module id = ./src/app/data/clients/images/spindal.png
// module chunks = 1 2 3